<script>
import documentMixin from "@/mixins/documentMixin";
import { mapActions, mapState } from "vuex";

export default {
  mixins: [documentMixin],
  data() {
    return {
      content: {
        rg: "",
        rgIssuingAuthority: "",
        rgIssuingState: "",
        issueState: "",
        issueDate: "",
        cpf: "",
        name: "",
        birthDate: ""
      }
    };
  },
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions("documents", ["setContent"]),

    updateContent() {
      let documentContent = {
        documentType: this.document.document_type,
        content: this.content
      };
      this.setContent(documentContent);
    }
  },
  mounted() {
    this.content = {
      ...this.content,
      ...this.document.content
    };
  }
};
</script>

<template>
  <v-layout align-center justify-space-between row fill-height wrap>
    <v-flex px-2 md6 xs12>
      <v-text-field
        name="rg"
        label="Numero registro"
        v-model="content.rg"
        @change="updateContent()"
        v-validate="'numeric'"
        :error-messages="errors.first('rg')"
        :error="errors.has('rg')"
      />
    </v-flex>

    <v-flex px-2 md6 xs12>
      <v-text-field
        name="rgIssuingAuthority"
        label="Orgao emissor"
        v-model="content.rgIssuingAuthority"
        @change="updateContent()"
        v-validate="'required|alpha_spaces'"
        :error-messages="errors.first('rgIssuingAuthority')"
        :error="errors.has('rgIssuingAuthority')"
      />
    </v-flex>

    <v-flex px-2 md6 xs12>
      <v-text-field
        name="issueState"
        label="Estado emissor"
        v-model="content.issueState"
        @change="updateContent()"
        v-validate="'required|alpha_spaces'"
        :error-messages="errors.first('issueState')"
        :error="errors.has('issueState')"
      />
    </v-flex>

    <v-flex px-1 md6 xs12>
      <v-text-field
        name="issueDate"
        label="Data de expedicao"
        v-model="content.issueDate"
        @change="updateContent()"
        :error-messages="errors.first('issueDate')"
        :error="errors.has('rgIssuingDate')"
        v-mask="'##/##/####'"
      />
    </v-flex>

    <v-flex px-1 md6 xs12>
      <v-text-field
        name="cpf"
        label="CPF"
        v-model="content.cpf"
        @change="updateContent()"
        :error-messages="errors.first('cpf')"
        :error="errors.has('cpf')"
        v-mask="'###.###.###-##'"
      />
    </v-flex>

    <v-flex px-1 md6 xs12>
      <v-text-field
        name="name"
        label="Nome"
        v-model="content.name"
        @change="updateContent()"
        v-validate="'required|alpha_spaces'"
        :error-messages="errors.first('name')"
        :error="errors.has('name')"
      />
    </v-flex>

    <v-flex px-1 md6 xs12>
      <v-text-field
        name="birthDate"
        label="Data de nascimento"
        v-model="content.birthDate"
        @change="updateContent()"
        :error-messages="errors.first('birthDate')"
        :error="errors.has('birthDate')"
        v-mask="'##/##/####'"
      />
    </v-flex>
  </v-layout>
</template>

<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Documents/DocumentContent.vue